import ChartBar from "components/chart/ChartBar";
import ChartBarHorizontal from "components/chart/ChartBarHorizontal";
import ChartLine from "components/chart/ChartLine";
import ChartPie from "components/chart/ChartPie";
import IndicadorDashboard from "components/chart/IndicadorDashboard";
import { ChartBarModel } from "model/chart/ChartBarModel";
import { ChartLineModel } from "model/chart/ChartLineModel";
import { ChartPieModel } from "model/chart/ChartPieModel";
import ItemDashboard from "model/dashboard/ItemDashboard";
import { useEffect, useState } from "react";
import DashboardService from "service/dashboard/DashboardService";

type Props = {
    value: ItemDashboard
}

const dashboardService = new DashboardService();
export default function ItemDashboardView(props: Props) {

    const [indicador, setIndicador] = useState<IndicadorDashboard | null>(null);
    const [graficoPizza, setGraficoPizza] = useState<ChartPieModel | null>(null);
    const [graficoLinha, setGraficoLinha] = useState<ChartLineModel | null>(null);
    const [graficoBarra, setGraficoBarra] = useState<ChartBarModel | null>(null);
    const [graficoBarraHorizontal, setGraficoBarraHorizontal] = useState<ChartBarModel | null>(null);

    const [chartWidth, setChartWidth] = useState<number>(window.innerWidth < 600 + 32 ? window.innerWidth - 32 : 600);
    const [indicatorWidth, setIndicatorWidth] = useState<number>(window.innerWidth < 350 ? window.innerWidth - 32 : 350);

    useEffect(() => {
        if (props.value.tipo === "INDICADOR") {
            dashboardService.buscarIndicador(props.value.codigoItem).then((response) => {
                setIndicador(response);
            }).catch((err) => {
                console.log(err);
            });
        }
        if (props.value.tipo === "GRAFICO_BARRA" || props.value.tipo === "GRAFICO_BARRA_HORIZONTAL") {
            dashboardService.buscarGraficoBarra(props.value.codigoItem).then((response) => {
                props.value.tipo === "GRAFICO_BARRA" ? setGraficoBarra(response) : setGraficoBarraHorizontal(response);
            }).catch((err) => {
                console.log(err);
            });
        }
        if (props.value.tipo === "GRAFICO_LINHA") {
            dashboardService.buscarGraficoLinha(props.value.codigoItem).then((response) => {
                setGraficoLinha(response);
            }).catch((err) => {
                console.log(err);
            });
        }
        if (props.value.tipo === "GRAFICO_PIZZA") {
            dashboardService.buscarGraficoPizza(props.value.codigoItem).then((response) => {
                setGraficoPizza(response);
            }).catch((err) => {
                console.log(err);
            });
        }
    }, [props.value])

    const renderIndicador = (indicador: IndicadorDashboard) => {
        const { imagem, valorTexto } = dashboardService.getIndicador(indicador, props.value.codigoItem);
        return (
            <div style={{ display: "flex", width: indicatorWidth, minHeight: 125, padding: 10, boxSizing: "border-box", borderRadius: 10, alignItems: 'center', backgroundColor: "#FFF", boxShadow: '3px 3px 10px 1px rgba(0,0,0,0.2)' }}>
                <img src={imagem} width={75} alt="" />
                <div style={{ display: "flex", flexDirection: "column", marginLeft: 15 }} >
                    <span style={{ fontSize: 18, fontWeight: 500, color: "#777" }}>{indicador.titulo}</span>

                    <div style={{ display: "flex", flexDirection: "column", marginLeft: 15 }}>

                        <span style={{ fontSize: 20, fontWeight: 700 }}>{valorTexto}</span>
                        <span style={{ fontSize: 14, fontWeight: 500 }}>{indicador.alvo}</span>

                    </div>
                </div>

            </div>
        )
    }

    useEffect(() => {
        const updateWindowDimensions = () => {
            console.log("innerWidth: " + window.innerWidth)
            setChartWidth(window.innerWidth < 600 + 32 ? window.innerWidth - 32 : 600);
            setIndicatorWidth(window.innerWidth < 350 ? window.innerWidth - 32 : 350);
        };

        window.addEventListener("resize", updateWindowDimensions);

        return () => window.removeEventListener("resize", updateWindowDimensions)

    }, []);




    const renderGraficoPizza = (grafico: ChartPieModel) => {
        return <div style={{ width: chartWidth, borderRadius: 20, alignItems: 'center', backgroundColor: "#FFF", boxShadow: '3px 3px 10px 1px rgba(0,0,0,0.2)' }}>
            <p style={{ fontSize: 18, fontWeight: 500, color: "#777", marginLeft: 20, marginTop: 10, paddingTop: 10 }} >{grafico.title}</p>
            <ChartPie width={chartWidth} height={250} data={grafico} moneyFormat />
        </div>
    }

    const renderGraficoLinha = (grafico: ChartLineModel) => {
        return <div style={{ width: chartWidth, borderRadius: 20, alignItems: 'center', backgroundColor: "#FFF", boxShadow: '3px 3px 10px 1px rgba(0,0,0,0.2)' }}>
            <p style={{ fontSize: 18, fontWeight: 500, color: "#777", marginLeft: 20, marginTop: 10, paddingTop: 10 }} >{grafico.title}</p>
            <ChartLine
                showTitle={false}
                width={"100%"}
                height={155}
                data={grafico}
                interpolation="natural"
            />
        </div>
    }

    const renderGraficoBarra = (grafico: ChartBarModel) => {
        const { tickValues, colorFunction, textFunction } = dashboardService.getGraficoBarra(grafico, props.value.codigoItem);
        return <div style={{ width: chartWidth, borderRadius: 20, alignItems: 'center', backgroundColor: "#FFF", boxShadow: '3px 3px 10px 1px rgba(0,0,0,0.2)' }}>
            <ChartBar
                showTitle
                data={grafico}
                width={chartWidth}
                height={300}
                tickValues={tickValues}
                colorFunction={colorFunction}
                textFunction={textFunction} />
        </div>
    }

    const renderGraficoBarraHorizontal = (grafico: ChartBarModel) => {
        const { tickValues, colorFunction } = dashboardService.getGraficoBarra(grafico, props.value.codigoItem);

        return <div style={{ width: chartWidth, borderRadius: 20, justifyContent: 'center', alignItems: "center", backgroundColor: "#FFF", boxShadow: '3px 3px 10px 1px rgba(0,0,0,0.2)' }}>
            <ChartBarHorizontal
                data={grafico}
                width={chartWidth}
                height={grafico.bars.length * 20 > 300 ? grafico.bars.length * 20 : 300}
                colorFunction={colorFunction}
            />
        </div>
    }
    return (
        <>
            {indicador && renderIndicador(indicador)}
            {graficoBarra && renderGraficoBarra(graficoBarra)}
            {graficoBarraHorizontal && renderGraficoBarraHorizontal(graficoBarraHorizontal)}
            {graficoPizza && renderGraficoPizza(graficoPizza)}
            {graficoLinha && renderGraficoLinha(graficoLinha)}
        </>
    )
}